export default __webpack_public_path__ + "static/media/alert-circle-auxiliary-red.692ddf66.svg";